// Pattern-of-Life (PoL): analyser et objekts posisjons-historikk for mønstre —
// hyppig besøkte steder (klynger), tid-på-døgnet-profil og «hjemme-/tilholds»-
// steder. Rent + deterministisk; input er posisjons-pings. Beslutningsstøtte for
// etterretning (predikere hvor/når et objekt dukker opp igjen).
import { haversineM } from './geo.js';
/**
 * Grådig romlig klynging: hver ping legges til nærmeste klynge innen radius,
 * ellers starter den en ny. Deterministisk (pings behandles i tidsrekkefølge).
 * Gir også tid-på-døgnet-histogram (UTC-time) og primærstedet.
 */
export function patternOfLife(pings, opts = {}) {
    const radius = opts.clusterRadiusM ?? 200;
    const sorted = [...pings].sort((a, b) => a.tsMs - b.tsMs);
    const byHourUtc = new Array(24).fill(0);
    const accs = [];
    for (const p of sorted) {
        byHourUtc[new Date(p.tsMs).getUTCHours()]++;
        const pos = { lat: p.lat, lon: p.lon };
        let best = null, bestD = Infinity;
        for (const a of accs) {
            const c = { lat: a.sumLat / a.count, lon: a.sumLon / a.count };
            const d = haversineM(c, pos);
            if (d <= radius && d < bestD) {
                best = a;
                bestD = d;
            }
        }
        if (best) {
            best.sumLat += p.lat;
            best.sumLon += p.lon;
            best.count++;
            best.lastMs = Math.max(best.lastMs, p.tsMs);
            best.firstMs = Math.min(best.firstMs, p.tsMs);
            best.members.push(pos);
        }
        else {
            accs.push({ sumLat: p.lat, sumLon: p.lon, count: 1, firstMs: p.tsMs, lastMs: p.tsMs, members: [pos] });
        }
    }
    const clusters = accs.map((a) => {
        const center = { lat: a.sumLat / a.count, lon: a.sumLon / a.count };
        const radiusM = a.members.reduce((mx, m) => Math.max(mx, haversineM(center, m)), 0);
        return { center, count: a.count, firstMs: a.firstMs, lastMs: a.lastMs, radiusM };
    }).sort((x, y) => y.count - x.count || x.firstMs - y.firstMs);
    return { clusters, byHourUtc, primarySite: clusters[0] ?? null };
}
/** Mest aktive klokketime(r) (UTC) fra et PoL-resultat. */
export function peakHoursUtc(pol) {
    const max = Math.max(0, ...pol.byHourUtc);
    if (max === 0)
        return [];
    return pol.byHourUtc.map((n, h) => ({ n, h })).filter((x) => x.n === max).map((x) => x.h);
}
//# sourceMappingURL=patternoflife.js.map